import { isEvitalsMonitoringPractice } from './practiceMonitoringUtils';

/** System caregiver role id (matches backend). */
export const SYSTEM_CAREGIVER_ROLE_ID = 7;

export function isSystemCaregiverRole(roleId) {
  return Number(roleId) === SYSTEM_CAREGIVER_ROLE_ID;
}

/** Normalize practices array from login user payload (may be partial). */
export function getPracticesFromUser(user) {
  if (!user) return [];
  const raw = user.practices;
  if (!Array.isArray(raw)) return [];
  return raw
    .map((p) => ({
      id: p.id ?? p.practice_id ?? p.practiceId,
      practice_name: p.practice_name ?? p.name ?? p.practiceName,
      evitals_monitoring: p.evitals_monitoring ?? p.evitalsMonitoring
    }))
    .filter((p) => p.id != null && p.id !== '')
    .filter(isEvitalsMonitoringPractice);
}

export function extractPracticesFromApiResponse(response) {
  let practicesData = [];
  if (response && response.data) {
    if (response.data.success) {
      if (response.data.data) {
        if (Array.isArray(response.data.data)) {
          practicesData = response.data.data;
        } else if (response.data.data.practices && Array.isArray(response.data.data.practices)) {
          practicesData = response.data.data.practices;
        } else if (response.data.data.data && Array.isArray(response.data.data.data)) {
          practicesData = response.data.data.data;
        }
      }
    } else if (Array.isArray(response.data)) {
      practicesData = response.data;
    } else if (response.data.practices && Array.isArray(response.data.practices)) {
      practicesData = response.data.practices;
    } else if (response.data.data && Array.isArray(response.data.data)) {
      practicesData = response.data.data;
    }
  }
  const unique = practicesData.filter(
    (practice, index, self) => index === self.findIndex((p) => String(p.id) === String(practice.id))
  );
  return Array.isArray(unique) ? unique : [];
}

export async function fetchAssignedPracticesForSystemCaregiver(practiceService, caregiverUserId) {
  if (!caregiverUserId) return [];
  const response = await practiceService.getPractices({
    limit: 1000,
    page: 1,
    minimal: 1,
    system_caregiver_id: caregiverUserId
  });
  const list = extractPracticesFromApiResponse(response);
  return list.filter(isEvitalsMonitoringPractice);
}
